// 相似宝贝页面
export default {
  routes: [
    // 相似宝贝页面
    {
      path: '/similar-goods',
      name: 'similar-goods',
      meta: {
        desc: '相似宝贝',
        pageId: 'B2732',
        level: 3
      },
      component: () =>
        import(/* webpackChunkName: "similarGoods" */ '../views/similarGoods/index.vue')
    }
  ]
}
